import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { GuardHelper } from '../_helpers/guardHelper';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class SystemGuard  {
  constructor(
    private router: Router, private authenticationService: AuthenticationService
  ) { }

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let activateRoles: string[] = ["WhitelabelAdmin"];
    const currentUser = this.authenticationService.currentUserValue;
    let authorized = currentUser.role.filter((item: string) => activateRoles.indexOf(item) > -1).length > 0;
    if (!authorized) {
      return this.router.parseUrl('settings');
    }
    return authorized;
  }
}
